import createCtx from 'coreUtils/createCtx';

export const [useCarouselContext, CarouselProvider] = createCtx<{
	isInCarousel: boolean;
	registerCarouselClassName: (key: string, className: string) => void;
	unRegisterCarouselClassName: (key: string, className: string) => void;
}>();
